module.exports = {"uploadbutton":"Upload"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/grouptour/create/button.json
// module id = c9bi
// module chunks = 58